import React, { FunctionComponent, useEffect, useState } from 'react';
import { ModalProps } from '@features/Modal';
import './OrderDrawer.scss';
import { Steps } from '@features/Steps';
import { GeneralTransactions } from './components/GeneralTransactions';
import { Button } from '@shared/UI';
import { HandleRefresh } from '@shared/react/hooks/useAsyncData/interfaces';
import snackbarStore from '@widgets/MainLayout/store/snackbar-store';
import { putOrder } from '@widgets/OrderTable/api';

interface IUserManagementViewModalProps extends ModalProps {
    order: any;
    accountsRefresh: HandleRefresh;
    VerificationModal?: FunctionComponent<any>;
    localStorageKey?: string;
}

export const OrderViewDrawer: React.FC<IUserManagementViewModalProps> = (props) => {
    const { order, localStorageKey, accountsRefresh, onClose } = props;

    const [editedValues, setEditedValues] = useState<any>(order);
    const [showSaveBtn, setShowBtn] = useState(false);
    const { setSnackbarMessage } = snackbarStore(); // Get the method to set the message
    const userStorage = localStorage.getItem('User');
    const userObject = JSON.parse(userStorage ? userStorage : '');

    useEffect(() => {
        if (JSON.stringify(order) !== JSON.stringify(editedValues)) {
            localStorage.setItem(localStorageKey || '', 'true');
        } else {
            localStorage.removeItem(localStorageKey || '');
        }
        setShowBtn(JSON.stringify(order) !== JSON.stringify(editedValues));
    }, [editedValues]);

    useEffect(() => {
        return () => {
            localStorage.removeItem(localStorageKey || '');
        };
    }, []);

    const putUser = async () => {
        try {
            await putOrder(editedValues);
            setSnackbarMessage('Successfully Updated Order!');
        } catch (error) {
            setSnackbarMessage('Failed to update order');
        }
        onClose?.();
        accountsRefresh();
    };

    return (
        <div className='widget-transaction-view-drawer'>
            <div className='symbol-class'>{order.symbol}</div>
            <div className='fdid-class'>Clearing Account: {order.account.fdid}</div>
            <Steps
                footerClassName='widget-transaction-view-drawer__footer'
                headerClassName='widget-transaction-view-drawer__header'
                className='widget-transaction-view-drawer__steps'
                headerStepLabelClassName='widget-transaction-view-drawer__header-step-label'
                headerStepLineClassName='widget-transaction-view-drawer__header-step-line'
                footerVisible={false}
            >
                <div>
                    <GeneralTransactions
                        OrderBody={order}
                        setEditedValues={setEditedValues}
                        editedValues={editedValues}
                    />
                    {!userObject && (
                        <Button
                            disabled={!showSaveBtn}
                            onClick={putUser}
                            className='widget-trade-status-table-drawer__save-btn-order'
                        >
                            Save changes
                        </Button>
                    )}
                </div>
            </Steps>
        </div>
    );
};
